import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PublicApiService } from '../../services/public-api.service';
import { Location } from '../../models/location.model';

declare var bootstrap: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  @Input() selectedLocation: Location | null = null;
  @Output() userAdded = new EventEmitter<void>();

  // User email
  userEmail: string = '';

  // Status
  statusText: string = '';
  statusTheme: string = 'light';

  // Submit button status
  submitButtonEnabled: boolean = false;

  constructor(private publicApiService: PublicApiService) {}

  ngOnInit(): void {}

  openAddUserModal() {
    // Reset the user email
    this.userEmail = '';

    // Initialize status to light theme
    this.statusText = '';
    this.statusTheme = 'light';

    // Initialize submit button as disabled
    this.submitButtonEnabled = false;

    // Get the modal element
    const modalElement = document.getElementById('addUserModal');

    // Create and show the modal
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  onEmailChange() {
    // Validate email format
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = emailRegex.test(this.userEmail);

    if (!this.userEmail) {
      this.statusText = '';
      this.statusTheme = 'light';
      this.submitButtonEnabled = false;
    } else if (!isValidEmail) {
      this.statusText = 'Invalid email format';
      this.statusTheme = 'danger';
      this.submitButtonEnabled = false;
    } else {
      this.statusText = 'Valid email';
      this.statusTheme = 'success';
      this.submitButtonEnabled = true;
    }
  }

  async submitAddUser() {
    if (!this.userEmail || !this.selectedLocation) {
      return;
    }

    console.log('Adding user:', this.userEmail, 'to location:', this.selectedLocation.label);

    try {
      // Call the API service to add the user to the location
      // await this.publicApiService.addUserToLocation(this.selectedLocation.uuid, this.userEmail);
      const userExists = await this.publicApiService.checkIfUserExists(this.userEmail);

      if(userExists){
        const addUserResult = await this.publicApiService.addExistingUserToLocation(this.selectedLocation.uuid, this.userEmail);
        if(addUserResult){
          this.statusText = 'User added successfully';
          this.statusTheme = 'success';
          this.submitButtonEnabled = false;
        }
      } else{
        const addUserResult = await this.publicApiService.createClaim(this.userEmail,this.selectedLocation.uuid);
        if(addUserResult){
          this.statusText = 'User added successfully: Claim Email Sent';
          this.statusTheme = 'success';
          this.submitButtonEnabled = false;
        }
      }
//rpasquarelli+u1222@gmail.com
      // Emit the event to notify the parent component that a user was added
      this.userAdded.emit();

      // Close the modal
      // this.closeModal();
    } catch (e: any) {
      console.error('Error adding user:', e);
      this.statusText = 'Failed to add user. Please try again.';
      this.statusTheme = 'danger';
      this.submitButtonEnabled = false;
    }
  }

  closeModal() {
    // Close the modal
    const modalElement = document.getElementById('addUserModal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Reset the state
    this.userEmail = '';
    this.statusText = '';
    this.statusTheme = 'light';
    this.submitButtonEnabled = false;
  }

  getSelectedLocationName(): string {
    return this.selectedLocation?.label || '';
  }
}
